var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.3818 17.5425L9.52015 19.4281L0.211662 10L9.52011 0.571911L11.3818 2.45753L3.93507 9.99997L11.3818 17.5425Z","fill":"black","fillOpacity":"0.6"}));
}

Arrow.defaultProps = {"width":"12","height":"20","viewBox":"0 0 12 20","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
